/**
 * PageContainer - Provides consistent padding and max-width for pages
 * Use this for pages that don't have their own full-width sub-navigation
 */
export function PageContainer({ children, maxWidth = '1400px' }) {
  return (
    <main style={{
      maxWidth,
      margin: '0 auto',
      padding: 'var(--space-6)',
      paddingBottom: '100px', // Extra space for mobile nav
    }}>
      {children}
    </main>
  );
}
